module.exports = __webpack_public_path__ + "img/wechat-icon.9c9909db.png";